<template>
  <!-- 包含PDF下载功能 和普通图片相册查看功能 -->
  <div class="preview-attachment">
    <!-- 有图片时展示查看按钮 -->
    <Button v-if="value?.length > 0" type="text" @click="handleView">
      <span :style="{ fontSize }">{{ BUTTON_text }}</span>
    </Button>
    <!-- 无图片时展示暂无图片 -->
    <span v-else>-</span>

    <!-- 预览附件 -->
    <preview-img-and-pdf
      v-model="visible"
      :data="attachs"
      :pdfScale="pdfScale"
      :zoomMin="zoomMin"
      :zoomMax="zoomMax"
      :domTransfer="domTransfer"
      :transfer="transfer"
    />
  </div>
</template>
<script setup>
import previewImgAndPdf from '../previewImgAndPdf.vue'
import previewImgAndPdfProps from '../../props/previewImgAndPdfProps'

import { ref, watch, computed } from 'vue'

const props = defineProps({
  ...previewImgAndPdfProps,
  value: {
    type: Array,
    default() {
      return []
    },
  },
  size: {
    type: [Number, String],
    default: 14,
  },
  BUTTON_text: {
    type: String,
    default: '查看附件',
  },
})
const visible = ref(false)
const attachs = ref([])

const fontSize = computed(() => {
  const size = `${props.size}`.replace(/%/g, '')
  if (/px$/i.test(`${size}`)) return size
  return `${size || 14}px`
})

//打开
const handleView = () => {
  const url = props.value?.[0]?.url
  if (url) {
    visible.value = true
    attachs.value = props.value
  }
}

watch(
  () => visible.value,
  (_visible) => {
    if (!_visible) attachs.value = [] // #37104, 优化可能出现加载不出 PDF 的问题
  }
)
</script>
